
<template>
    <div class="form-overlay select-hashtag" :class="position" >   

        <div class="steep1">
            <!-- <div class="nav-network hide-scrollbar">
                <div class="list-item-network">
                    <div class="item-network" v-if="this.pagesSelected.find(p=> p.network == 'instagram')" :class="{active : networkSelected == 'instagram'}" @click="()=>selectNetwork('instagram')"><i class="fa-brands fa-instagram"></i></div>
                </div>
            </div> -->
            <div class="content searchHashtag">
                <div class="input">
                    <i class="fa-regular fa-magnifying-glass"></i>
                    <input placeholder="Recherche de hashtag instagram" v-model="textSearch" v-on:keyup.enter="sendSearchHashtags" ref="inputSearch">
                </div>
                <div class="list-item hide-scrollbar">
                    <span class="loader" v-if="stateLoader"></span>
                    <div class="item" v-else v-for="(hashtag, index) in (listHashtagAvailable.length ? listHashtagAvailable : listHashtagSelect)" @click="selectHashtag(hashtag)" :key="`hashtag${index}`">
                        <div class="icon selected" v-if="listHashtagSelect.find(v => v.hashtag == hashtag.hashtag)">
                            <i class="fa-solid fa-check"></i>
                        </div>
                        <div class="icon" v-else>
                            <i class="fa-regular fa-hashtag"></i>
                        </div>
                        
                        <div class="info">
                            <p class="name">#{{ hashtag.hashtag }}</p>
                            <p class="count">Sur <span class="countHashtag">{{hashtag.count}}</span> posts</p>
                        </div>
                    </div>
                    
                </div>
            </div>

        </div>
        <div class="btns">
            <div v-if="listHashtagSelect.length" class="btn-secondary" @click="apply">Appliquer ({{ listHashtagSelect.length }})</div>
            <div class="btn-secondary" @click="close">Fermer</div>
        </div>
       

       
    </div>
</template>


<script>
    import { EventBus } from '@/event-bus';
    import store from './../../../../store/index.js'
    import Queuer from '../../../../utils/Queuer.js'
    import minxinBot from '../../../mixins/Bots.vue'


    export default {
        mixins: [minxinBot],
        props: {
            id: String,

            position: {
                type: String,
                default: 'left'
            },
        },
       

        data() {
            return {
                steep : 1,
                textSearch : '',
                lastIdEvent : 0,
                stateLoader : false,
                listHashtagAvailable : [],
                listHashtagSelect : [],
                timeoutInitSearch : null,
                networkSelected :  'instagram',

                saveUrlPictureUser : {},
                queueLoadImage : null
            }
        },

        created () {
            EventBus.$on('resultSearchFromSelectHashtags', this.receveidHashtags);
        },

        mounted() {
            this.sendSearchHashtags()
            this.$nextTick(() => {
                this.$refs.inputSearch.focus();
            })
        },

        methods: {
            close() {
                this.$emit('close')
            },

            apply() {
                EventBus.$emit("eventApplyFromSelectHashtags",this.networkSelected, this.listHashtagSelect.map(v => v.hashtag), this.id)
                this.$emit('close')
            },

            sendSearchHashtags() {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.lastIdEvent = new Date().getTime()
                EventBus.$emit("eventSearchFromSelectHashtags",this.textSearch, this.networkSelected, this.lastIdEvent, this.id)
            },

            async receveidHashtags(hashtags,idEvent) {
                if ( this.lastIdEvent == idEvent) {
               
                    this.stateLoader = false

                    if (hashtags) {

                        this.listHashtagAvailable = hashtags.map(hashtagObject => ({...hashtagObject, count : (hashtagObject.count).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}))
                    }else{
                        this.listHashtagAvailable  = []
                        return
                    }
                }
            },

            selectHashtag(hashtag) {
                if (this.listHashtagSelect.find(v => v.hashtag == hashtag.hashtag)) {
                    this.listHashtagSelect = this.listHashtagSelect.filter(value => value.hashtag !== hashtag.hashtag)
                }else {
                    this.listHashtagSelect = [...this.listHashtagSelect, hashtag]
                }
            },

            selectNetwork(network) {
                if (this.networkSelected !== network) {
                    this.listHashtagAvailable = []
                }
                
                this.networkSelected = network
                this.sendSearchHashtags() 
            },

            getUsername(person) {
                switch (this.networkSelected) {
                    case 'facebook' : {
                        return person.name ? person.name : person.id
                    }
                    case 'linkedin': {
                        return person.name ? person.name : person.id
                    }
                    case 'twitter': {
                        return person.name ? person.name : person.id
                    }
                    default: {
                        return person.id ? person.id : person.name
                    }
      
                }
            },


            getSubName(person) {
                switch (this.networkSelected) {
                    case 'facebook': {
                        return person.id ? person.id : person.name
                    }
                    case 'linkedin': {
                        return person.name ? person.name : person.id
                    }
                    case 'twitter': {
                        return person.username ? person.username : person.id
                    }
                        
                
                    default: {
                        return person.id ? person.id : person.name
                    }
                }
            },

            getPicture(person) {

                switch (this.networkSelected) {
                    case 'twitter': {
                        return person.profile_image_url ? person.profile_image_url : 'img/avatar.jpg'
                    }

                    case 'facebook':  {
                        return this.saveUrlPictureUser[person.id] ? this.saveUrlPictureUser[person.id] : 'img/avatar.jpg'
                    }
                
                    default: {
                        return person.image ? person.image : 'img/avatar.jpg'
                    }
                }

                
            }

        },

        computed: {
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'];
            },
        },

        watch: {
            textSearch(newValue, oldValue) {
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.timeoutInitSearch = setTimeout(() => {
                    this.sendSearchHashtags()
                },1000)
            },      
        },

        beforeDestroy () {
            EventBus.$off('resultSearchFromSelectHashtags', this.receveidHashtags);
        }
    }
</script>
    